<template>
    <modal v-model:show="modal"
           body-classes="p-0"
           modal-classes="modal-dialog-centered modal-sm">
        <card type="secondary" shadow
            header-classes="bg-secondary text-center"
            body-classes="px-lg-4 py-lg-5"
            footer-classes="bg-secondary d-flex justify-content-center align-items-center"
            class="border-0"
        >
            <template #header>
                <span>{{$t('dashboard.plans')}}</span>
            </template>
            <template v-if="true">
                <div class="list-group">
                    <button
                        v-for="plan in plans"
                        :key="plan.id"
                        class="list-group-item list-group-item-action"
                        @click="$emit('onSelect', plan)"
                    >
                        {{ plan.translation.name }}
                    </button>
                </div>
            </template>
            <template #footer>
                <base-pagination 
                    class="mb-0" 
                    :page-count="meta.last_page" 
                    v-model="meta.current_page"
                    @input="onChangePage"
                    type="#525F7F"
                ></base-pagination>
            </template>
        </card>
    </modal>
</template>

<script>
import Modal from '../../argon/components/Modal'
import Card from '../../argon/components/Cards/Card'
import BasePagination from '../../argon/components/BasePagination'

export default {
    name: 'PlanSelectModal',
    components: {
        Modal,
        Card,
        BasePagination
    },
    props: {
        value: {
            type: Boolean,
            required: true
        },
        color: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            plans: [],
            links: {},
            meta: {}
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        iso() {
            return localStorage.getItem('lang')
        },
        data: {
            get() {
                return this.value
            },
            set(value) {
                this.plans = value.data
                this.links = value.links
                this.meta = value.meta
            }
        }
    },
    methods: {
        getPlans() {
            if(this.$store.getters.USER.public) {
                return;
            }
            this.$loading.show()

            window.axios.get(`/api/app/plans/${this.iso}/5`, {
                params: {
                    page: this.meta.current_page ? this.meta.current_page : 1
                }
            })
            .then(res => {
                this.data = res.data
            })
            .catch(err => console.error(err))
            .finally(() => this.$loading.close())
        },
        onChangePage(page) {
            this.meta.current_page = page
            this.getPlans()
        }
    },
    mounted() {
        this.getPlans()
    }
}
</script>

<style>

</style>
